import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows:8vh auto auto auto auto auto;
  grid-template-areas: "header header" "section_start section_start"
  "area_variation area_variation" "indicator_synthesis indicator_synthesis" "AreaVariationBest AreaVariationBest" "footer footer";
  background-color: white;
  .leaflet-container{
  background-color: transparent;
  }
 .MapArticle{
  grid-area: map;
  display: flex;
  justify-content: center;
  width: 100%;
  height: auto;
  min-height: 320px;
  flex-direction: column;
  .boxLegend{
    position: relative;
    left: 40px;
    width: 100px;
    bottom: 60px;
  }

 
 }
  section{
    grid-area: section_start ;
   .contente{
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: auto;
   }
   .section{
    display: flex;
    width: 1176px;
   }
   .boxFather{
    display: flex;
    width: 1176px;
    margin-top: 50px;
    height: 100px;
    justify-content: flex-start;
   }
   .overContainer{
    display: flex;
    width: 1200px;
    position: absolute;

    .boxText{
      width: 910px;
        small{
          font: normal normal bold 12px/12px Poppins;
          letter-spacing: 2.4px;
          color: #C4C3C3;
        }
      .wraper{
        display: flex;
        align-items: center;
      }
    }

    h4{
      width: 80%;
      margin: 0;
      font-size: 1.2rem;
      font-weight: bold;
    }
   }

   @media (max-width: 820px) {
    .contente{
      display: none;
    }
   }
  }

  @media (max-width: 820px) {
    grid-template-columns: 1fr;
    grid-template-rows: 15vh auto auto auto 5vh auto -1vh minmax(0vh, 100%);
    grid-template-areas: "header" "selectorMobile" "map" "graphMobile" "area_variation" "indicator_synthesis" "footer";

   
}
@media (min-width: 820px) {
  .MapArticle{
      display: none;
    }
}
`;
export const BtnFindMore = styled.div`

width: 90px;
height: 21px;
background: #20725E 0% 0% no-repeat padding-box;
border-radius: 22px;
opacity: 1;
display: flex;
justify-content: center;
align-items: center;
margin-left: 10px;
p{
  text-align: left;
font: normal normal 600 11px/18px Poppins;
letter-spacing: 0.55px;
color: #FFFFFF;
opacity: 1;

}

&:hover{
  cursor: pointer;
  background: #20725E80 0% 0% no-repeat padding-box;
}
`


export const MapTest = styled.div`
width: 100%;
height: 100px;
background-color: red;
grid-area: teste;
`

export const TooltiModalContainer = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`